import { Cell } from '@pelckmans/elementis/components/table/cell';
import { calculateScore } from '../../../../../../shared-components/elementis/util/calculateScore';

export default function PercentageCell({
  achieved,
  maximum,
  needsGrading,
}: {
  achieved?: number;
  maximum?: number;
  needsGrading?: boolean;
}) {
  return achieved === undefined || maximum === undefined || needsGrading ? (
    <Cell minWidth="xs" maxWidth="xs" />
  ) : (
    <Cell pillGroupProps={{ 'aria-label': undefined, role: 'group' }} minWidth="xs" maxWidth="xs">
      <Cell.Pill>{calculateScore({ achieved, maximum })}%</Cell.Pill>
    </Cell>
  );
}
